import { BellAlertIcon } from '@heroicons/react/24/outline';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/UI/dialog';

/**
 * Soft-ask priming screen shown before the native OS notification prompt. It
 * explains why to enable notifications so the user makes an informed choice
 * (and we don't burn the one-shot OS prompt on a cold, contextless ask).
 * "Enable notifications" triggers the real OS prompt; "Not now" defers.
 */
export function PushPrimingModal({
  open,
  onEnable,
  onDismiss,
}: {
  open: boolean;
  onEnable: () => void;
  onDismiss: () => void;
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          onDismiss();
        }
      }}
    >
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-900/40">
            <BellAlertIcon
              className="size-6 text-emerald-600 dark:text-emerald-400"
              aria-hidden="true"
            />
          </div>
          <DialogTitle className="text-center">Get release alerts</DialogTitle>
          <DialogDescription className="text-center">
            We'll send a heads-up for release warnings and service updates, so you know when a
            release is coming. The plays themselves always live in the Release Center. You can
            change this anytime in Settings.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2 flex flex-col gap-2">
          <button
            type="button"
            onClick={onEnable}
            className="rounded-xl bg-emerald-600 py-3 text-center text-sm font-semibold text-white transition hover:bg-emerald-700"
          >
            Enable notifications
          </button>
          <button
            type="button"
            onClick={onDismiss}
            className="rounded-xl py-3 text-center text-sm font-semibold text-zinc-500 transition hover:bg-zinc-50 dark:text-zinc-400 dark:hover:bg-white/5"
          >
            Not now
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
